import { HttpClient, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { SafeAny } from '../../types/safe-any';

import { Client, ClientPayload, Country, State } from './clients.state.interface';

@Injectable({
  providedIn: 'root',
})
export class ClientsService {
  private readonly httpClient = inject(HttpClient);

  getClients(payload: SafeAny): Observable<HttpResponse<Client[]>> {
    return this.httpClient.get<Client[]>(`${environment.apiUrl}/clients`, {
      params: payload,
      observe: 'response',
    });
  }

  addClient(payload: ClientPayload): Observable<Client> {
    return this.httpClient.post<Client>(`${environment.apiUrl}/clients`, payload);
  }

  getClient(clientId: string): Observable<Client> {
    return this.httpClient.get<Client>(`${environment.apiUrl}/clients/${clientId}`);
  }

  updateClient(payload: ClientPayload, clientId: string): Observable<Client> {
    return this.httpClient.put<Client>(`${environment.apiUrl}/clients/${clientId}`, payload);
  }

  duplicateClient(clientId: string): Observable<Client> {
    return this.httpClient.post<Client>(`${environment.apiUrl}/clients/${clientId}/duplicate`, {});
  }

  getCountries(payload: SafeAny): Observable<Country[]> {
    return this.httpClient.get<Country[]>(`${environment.apiUrl}/countries`, {
      params: payload,
    });
  }

  getStates(payload: SafeAny): Observable<State[]> {
    return this.httpClient.get<State[]>(`${environment.apiUrl}/states`, {
      params: payload,
    });
  }
}
